import { Action, createAction, createReducer, on, props } from '@ngrx/store';
import merge from 'lodash/merge';

export const setTabkey = createAction('[Tabkey] Set tabkey Info', props<{ key: string }>());
export const mergeTabkey = createAction('[Tabkey] Merge tabkey Info', props<Partial<{ key: string }>>());
export const resetTabkey = createAction('[Tabkey] Reset Empty tabkey');

export function tabkeyReducer(pState: string | undefined, action: Action) {
  return createReducer(
    {},
    on(setTabkey, (state, tabkey) => tabkey),
    on(mergeTabkey, (state, tabkey) => merge({}, state, tabkey)),
    on(resetTabkey, state => null)
  )(pState, action);
}
